import { pluralize } from "web/services/inflector"

export default function useListFetchURL({
  subjectType,
  subjectId,
  topic,
  parentSubjectType,
  parentSubjectId,
  url,
  enableLocationIndex,
}) {
  if (url && enableLocationIndex) return url + "/map_locations"
  if (url) return url

  const hasSubject = subjectId !== undefined
  const hasParentSubjectType = parentSubjectType !== undefined
  const hasParentSubject = parentSubjectId !== undefined
  const hasTopic = topic !== undefined

  const urlParts = [pluralize(subjectType)]

  if (hasParentSubjectType) {
    if (hasParentSubject) {
      urlParts.unshift(parentSubjectId)
    }
    urlParts.unshift(pluralize(parentSubjectType))
  }

  if (hasTopic) {
    urlParts.push(...[hasSubject ? subjectId : "topic", topic])
  }

  if (enableLocationIndex) {
    urlParts.push("map_locations")
  }

  return `/${urlParts.join("/")}`
}
